/** Registra il periodo e la posizione di fruizione di un contenuto da parte di un utente. */
export class CourseContentTrackerDTO {
  public id: number;
  public idContent: number;
  public idUser: number;
  public startDate: string | Date;
  public stopDate: string | Date;
  public startPosition: number;
  public stopPosition: number;
  public created: Date;
}
